import {lifecycle} from 'recompose';

export default lifecycle({

  componentDidUpdate() {
  },

  componentDidMount() {
    this.props.listCareUnits()
  }

});